export default __webpack_public_path__ + "static/media/_DSC0433.c52ca8ce.JPG";